import { clearableDateSchema } from '@bos/form';
import { z } from 'zod';

import { BANK_INCEPTION_DATE } from '../../../../../../../constants';

const TIMESTAMP_MAX_DATE = new Date();

export type ClientBankIdentityHistoryOfUseFilterFormErrorMessages = {
	dateCantBeEarlierThanBankInceptionDateError: string;
	dateMustBeTodayAtLatestError: string;
	dateToMustBeBeforeDateFromError: string;
};

export const CLIENT_BANK_IDENTITY_HISTORY_OF_USE_FILTER_DEFAULT_VALUES: ClientBankIdentityHistoryOfUseFilterForm =
	{
		timestampTo: null,
		timestampFrom: null,
	};

export const getClientBankIdentityHistoryOfUseFilterFormSchema = (
	errorMessages?: ClientBankIdentityHistoryOfUseFilterFormErrorMessages,
) => {
	const schema = z
		.object({
			timestampTo: clearableDateSchema(
				z.coerce
					.date()
					.min(BANK_INCEPTION_DATE, {
						message: errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
					})
					.max(TIMESTAMP_MAX_DATE, {
						message: errorMessages?.dateMustBeTodayAtLatestError,
					}),
			).nullable(),
			timestampFrom: clearableDateSchema(
				z.coerce
					.date()
					.min(BANK_INCEPTION_DATE, {
						message: errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
					})
					.max(TIMESTAMP_MAX_DATE, {
						message: errorMessages?.dateMustBeTodayAtLatestError,
					}),
			).nullable(),
		})
		.superRefine(({ timestampFrom, timestampTo }, ctx) => {
			if (timestampTo && timestampFrom) {
				if (timestampFrom > timestampTo) {
					ctx.addIssue({
						code: 'custom',
						message: errorMessages?.dateToMustBeBeforeDateFromError,
						path: ['timestampTo'],
					});
				}
			}
		});

	return schema;
};
export type ClientBankIdentityHistoryOfUseFilterForm = z.infer<
	ReturnType<typeof getClientBankIdentityHistoryOfUseFilterFormSchema>
>;
